import * as React from 'react';
import theme from '../../utils/theme';
import { BaseForm } from './Base';

const base = (props: any) => {
  const opacity = props.disabled ? 'o-50' : 'o-100';

  return `${theme.form.field.input} ${opacity}`;
};

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export interface NumberFieldProps extends InputProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export const NumberField = ({
  label,
  id,
  tooltip,
  field,
  type,
  onValueChange,
  ...rest
}: NumberFieldProps) => (
  <BaseForm label={label} id={id} tooltip={tooltip}>
    <input
      className={base(rest)}
      id={id}
      type="number"
      onChange={(e) => onValueChange(field, parseFloat(e.target.value))}
      {...rest}
    />
  </BaseForm>
);

export default NumberField;
